import { DocumentReport, UsageReportItem } from "../models/DocumentReport";
import { FilterValue } from "../models/FilterValue";
import { ServerName } from "../utils/constants/serverName";
import axios from "../utils/http/axios";
export const getDocumentReport = async (params?: URLSearchParams) => {
  return axios
    .get<DocumentReport[]>(`${ServerName}/documentreport`, {
      params: params,
    })
    .then((result) => {
      if (result.data.length > 0) {
        result.data = result.data.sort(
          (a, b) => b.countActiveDocs - a.countActiveDocs
        );
      } else {
        Promise.resolve([]);
      }
      return Promise.resolve(result.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
export const getMonthlyReport = async () => {
  const params = new URLSearchParams();
  params.set("type", "monthlyvalues");

  return axios
    .get<[string, number | string, string, number][]>(
      `${ServerName}/documentreport`,
      {
        params: params,
      }
    )
    .then((result) => {
      return Promise.resolve(result.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getReport = async(reportType : "cases" | "documents", fromDate? : string, toDate?: string) => {
  const params = new URLSearchParams();
  params.append("reportType", reportType);
  if(fromDate && toDate){
    params.append("fromDate", fromDate);
    params.append("toDate", toDate);
  }
  try{

    const result = await axios.get<UsageReportItem[]>(`${ServerName}/statistics`, {params: params})
    return Promise.resolve(result.data);
  }
  catch(e){
    return Promise.reject("Unable to get report")
  }

}

export const getOverviewReport = async() => {
  const params = new URLSearchParams();
  params.append("reportType", "overview");
  try{

    const result = await axios.get<{itemType: string; countTotal: number;}[]>(`${ServerName}/statistics`, {params: params})
    return Promise.resolve(result.data);
  }
  catch(e){
    return Promise.reject("Unable to get overview report")
  }

}

export const getFilterValues = async (filterType: "cases" | "documents", caseType? :string) => {
  const params = caseType ?  { filterType: filterType, caseType:caseType } :  { filterType: filterType };
   
  return axios
    .get<FilterValue[]>(`${ServerName}/filtervalues`, {
      params,
    })
    .then((result) => {
      const data = [...result.data];
      data.forEach((filterType) => {
        filterType.values.forEach((o, i, a) => {
          if (a[i] == null) {
            a[i] = "";
          }
        });
      });

      return Promise.resolve(data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
